module.exports = __webpack_public_path__ + "img/eu_get.ef6e90d.png";